export default __webpack_public_path__ + "assets/51cde6da51c1660bf5e79f4ac6695483.png";